import { flatSchema as addressSchema } from 'components/Address/util';
import { bool, func, object, shape, string } from 'prop-types';
import React, { Fragment } from 'react';
import { useFormContext } from 'react-hook-form';
import Alert from '@johnlewispartnership/wtr-ingredients/ingredients/Alert';
import Spinner from '@johnlewispartnership/wtr-ingredients/ingredients/Spinner';
import PageTitle from '@johnlewispartnership/wtr-ingredients/ingredients/PageTitle';
import styles from './AddressForm.scss';
import AddressName from './AddressName';
import Form from './Form';

const addressFormDefaultPropSetJustSelectedFromAddressFinder = () => {};
const addressFormDefaultPropPostalCodeCheck = () => Promise.resolve('');

const AddressForm = ({
  datatag,
  hasError = false,
  hasFoundAddress,
  setJustSelectedFromAddressFinder = addressFormDefaultPropSetJustSelectedFromAddressFinder,
  isRegistering = false,
  initialValues,
  loading = false,
  loadingMessage = '',
  manualOnly,
  onSubmitErrorScroll,
  pageTitle,
  submitText,
  ukOnlyAddress = false,
  extraValidations = null,
  postalCodeCheck = addressFormDefaultPropPostalCodeCheck,
}) => {
  const formContext = useFormContext();
  const { isContactAddress } = initialValues;

  return (
    <Fragment>
      {loading && (
        <div className={styles.spinnerOverlay}>
          <div className={styles.spinnerMargin}>
            <Spinner isActive={loading} />
          </div>
          {loadingMessage && <p className={styles.spinnerDescription}>{loadingMessage}</p>}
        </div>
      )}
      {pageTitle && (
        <div>
          <PageTitle
            className={styles.title}
            id="selectAddressModalTitle"
            theme="underline"
            title={isContactAddress ? 'Edit Contact Address' : pageTitle}
          />
        </div>
      )}
      <form data-testid={datatag}>
        {hasError && (
          <div id="addressApiError" className={styles.addressApiError}>
            <Alert
              type="error"
              title="Something went wrong."
              message="Apologies something went wrong when saving your address. Please try again or at a later time."
              dataTest="address-form-error"
            />
          </div>
        )}
        <AddressName
          initialValues={initialValues}
          formContext={formContext}
          extraValidations={extraValidations}
          isRegistering={isRegistering}
        />
        <Form
          hasFoundAddress={hasFoundAddress}
          setJustSelectedFromAddressFinder={setJustSelectedFromAddressFinder}
          initialValues={initialValues}
          manualOnly={manualOnly}
          onSubmit={onSubmitErrorScroll}
          submitText={submitText}
          ukOnlyAddress={ukOnlyAddress}
          formContext={formContext}
          postalCodeCheck={postalCodeCheck}
        />
      </form>
    </Fragment>
  );
};

AddressForm.propTypes = {
  datatag: string.isRequired,
  extraValidations: object,
  setJustSelectedFromAddressFinder: func,
  isRegistering: bool,
  hasError: bool,
  hasFoundAddress: bool.isRequired,
  initialValues: shape(addressSchema).isRequired,
  loading: bool,
  loadingMessage: string,
  manualOnly: bool.isRequired,
  onSubmitErrorScroll: func.isRequired,
  pageTitle: string.isRequired,
  submitText: string.isRequired,
  ukOnlyAddress: bool,
  postalCodeCheck: func,
};

export default AddressForm;
